// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar styles */
.sidebar {
  /* height: 90%; */
  /* z-index: 5000; */
  background-color: transparent;
  color: white;
  /* display: flex; */
  flex-direction: column;
  gap: 1rem;
  overflow-y: auto; /* Enable vertical scrolling */
  max-height: 100%; /* Ensure it doesn't exceed the viewport height */
}

.sidebar h2 {
  font-size: 1.2rem;
  margin-bottom: 1rem;
}

.sidebar a {
  color: #ccc;
  text-decoration: none;
  padding: 0.5rem 1rem;
  border-radius: 10px;
  transition: 0.2s;
  cursor: pointer;
}

.sidebar a.active {
  background-color: #deb841; /* Gold background for active link */
  color: black;
  font-weight: bold;
}

.sidebar .client-nav {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

/* Sidebar drawer styles */
.sidebar-drawer {
  position: fixed; /* Ensure it is positioned off-screen initially */
  top: 0;
  z-index: 1000; /* Ensure it is above other content */
  left: -240px; /* Move it off-screen */
  width: 240px;
  height: 100%;
  transition: left 0.3s ease; /* Smooth transition for opening/closing */
  /* background-color: rgba(46, 39, 90, 0.9); #2e275a; */

  background-color: #161717;
  color: white;
}

.sidebar-drawer.open {
  left: 0; /* Bring it into view when open */
}

.sidebar-overlay {
  display: block;
  position: fixed;
  z-index: 1100;
  top: 0;
  left: 0;
  width: 100vw;
  /* height: 100%; */
  background: rgba(44, 36, 90, 0.45);
  backdrop-filter: blur(1px);
}

.sidebar-close-btn {
  display: block !important;
  /* position: absolute;
  top: 12px;
  right: 16px; */
  background: transparent;
  border: 0;
  color: white;
  font-size: 32px;
  z-index: 1200;
  cursor: pointer;
}

/* Sidebar toggle button styles */
.sidebar-toggle-btn {
  display: block;
  background-color: #161717;
  color: #42bbd8; /* Slightly darker background on hover */
  padding: 2.5rem;
  border: 0;
  font-size: 48px;
  z-index: 1200;
  cursor: pointer;
  position: absolute;
  top: 16px;
  right: -80px; /* Position outside the sidebar */
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: right 0.3s ease, background-color 0.2s, transform 0.2s;
}


.sidebar-toggle-btn:hover {
  background-color: #333; /* Slightly darker background on hover */
  transform: scale(1.1); /* Slightly enlarge the button */
}

.sidebar-drawer.open .sidebar-toggle-btn {
  right: -40px; /* Adjust position when open */
}

@media (min-width: 1024px) {
  .sidebar-toggle-btn {
    width: 120px;
    height: 120px;
    font-size: 64px;
    right: -140px; /* Adjust position to keep it visible */
  }
}

/* Sidebar links and dropdowns */
.sidebar-link {
  display: block;
  margin: 1rem 0;
  padding: 0.25rem 0.75rem;
  color: white;
  text-decoration: none;
  cursor: pointer;
}

.sidebar-link:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: #FFD700; /* Gold color on hover */
}

.sidebar-link.active {
  font-weight: bold;
  color: #FFD700;
}

.sidebar-dropdown {
  margin: 1.0rem 0.4rem;
  padding-left: 0.5rem;
  cursor: pointer;
}
.sidebar-dropdown-header:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: #FFD700; 
}

.sidebar-dropdown summary {
  cursor: pointer;
  font-weight: bold;
  list-style: none;
  color: white;
  padding: 0.25rem 0.5rem;
}

.sidebar-nested {
  margin-left: 1rem;
  padding-left: 0.5rem;
  border-left: 1px solid rgba(255, 255, 255, 0.1);
}

/* Logo styles */
.sidebar-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 0;
  margin-top: 100px;
  background-color: transparent !important;

}

.sidebar-logo-img {
  width: 80%; /* Adjust the width to control the size */
  max-width: 150px; /* Set a maximum width */
  border-radius: 6px;
}`, "",{"version":3,"sources":["webpack://./src/SidebarNav.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,gBAAgB,EAAE,8BAA8B;EAChD,gBAAgB,EAAE,iDAAiD;AACrE;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB,EAAE,oCAAoC;EAC/D,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,eAAe,EAAE,iDAAiD;EAClE,MAAM;EACN,aAAa,EAAE,qCAAqC;EACpD,YAAY,EAAE,uBAAuB;EACrC,YAAY;EACZ,YAAY;EACZ,0BAA0B,EAAE,0CAA0C;EACtE,sDAAsD;;EAEtD,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,OAAO,EAAE,iCAAiC;AAC5C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,MAAM;EACN,OAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB;;gBAEc;EACd,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,aAAa;EACb,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,cAAc;EACd,yBAAyB;EACzB,cAAc,EAAE,wCAAwC;EACxD,eAAe;EACf,SAAS;EACT,eAAe;EACf,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,YAAY,EAAE,iCAAiC;EAC/C,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kEAAkE;AACpE;;;AAGA;EACE,sBAAsB,EAAE,wCAAwC;EAChE,qBAAqB,EAAE,gCAAgC;AACzD;;AAEA;EACE,YAAY,EAAE,8BAA8B;AAC9C;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,eAAe;IACf,aAAa,EAAE,uCAAuC;EACxD;AACF;;AAEA,gCAAgC;AAChC;EACE,cAAc;EACd,cAAc;EACd,wBAAwB;EACxB,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,cAAc,EAAE,wBAAwB;AAC1C;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,wCAAwC;;AAE1C;;AAEA;EACE,UAAU,EAAE,yCAAyC;EACrD,gBAAgB,EAAE,wBAAwB;EAC1C,kBAAkB;AACpB","sourcesContent":["/* Sidebar styles */\n.sidebar {\n  /* height: 90%; */\n  /* z-index: 5000; */\n  background-color: transparent;\n  color: white;\n  /* display: flex; */\n  flex-direction: column;\n  gap: 1rem;\n  overflow-y: auto; /* Enable vertical scrolling */\n  max-height: 100%; /* Ensure it doesn't exceed the viewport height */\n}\n\n.sidebar h2 {\n  font-size: 1.2rem;\n  margin-bottom: 1rem;\n}\n\n.sidebar a {\n  color: #ccc;\n  text-decoration: none;\n  padding: 0.5rem 1rem;\n  border-radius: 10px;\n  transition: 0.2s;\n  cursor: pointer;\n}\n\n.sidebar a.active {\n  background-color: #deb841; /* Gold background for active link */\n  color: black;\n  font-weight: bold;\n}\n\n.sidebar .client-nav {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n}\n\n/* Sidebar drawer styles */\n.sidebar-drawer {\n  position: fixed; /* Ensure it is positioned off-screen initially */\n  top: 0;\n  z-index: 1000; /* Ensure it is above other content */\n  left: -240px; /* Move it off-screen */\n  width: 240px;\n  height: 100%;\n  transition: left 0.3s ease; /* Smooth transition for opening/closing */\n  /* background-color: rgba(46, 39, 90, 0.9); #2e275a; */\n\n  background-color: #161717;\n  color: white;\n}\n\n.sidebar-drawer.open {\n  left: 0; /* Bring it into view when open */\n}\n\n.sidebar-overlay {\n  display: block;\n  position: fixed;\n  z-index: 1100;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  /* height: 100%; */\n  background: rgba(44, 36, 90, 0.45);\n  backdrop-filter: blur(1px);\n}\n\n.sidebar-close-btn {\n  display: block !important;\n  /* position: absolute;\n  top: 12px;\n  right: 16px; */\n  background: transparent;\n  border: 0;\n  color: white;\n  font-size: 32px;\n  z-index: 1200;\n  cursor: pointer;\n}\n\n/* Sidebar toggle button styles */\n.sidebar-toggle-btn {\n  display: block;\n  background-color: #161717;\n  color: #42bbd8; /* Slightly darker background on hover */\n  padding: 2.5rem;\n  border: 0;\n  font-size: 48px;\n  z-index: 1200;\n  cursor: pointer;\n  position: absolute;\n  top: 16px;\n  right: -80px; /* Position outside the sidebar */\n  border-radius: 50%;\n  width: 60px;\n  height: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: right 0.3s ease, background-color 0.2s, transform 0.2s;\n}\n\n\n.sidebar-toggle-btn:hover {\n  background-color: #333; /* Slightly darker background on hover */\n  transform: scale(1.1); /* Slightly enlarge the button */\n}\n\n.sidebar-drawer.open .sidebar-toggle-btn {\n  right: -40px; /* Adjust position when open */\n}\n\n@media (min-width: 1024px) {\n  .sidebar-toggle-btn {\n    width: 120px;\n    height: 120px;\n    font-size: 64px;\n    right: -140px; /* Adjust position to keep it visible */\n  }\n}\n\n/* Sidebar links and dropdowns */\n.sidebar-link {\n  display: block;\n  margin: 1rem 0;\n  padding: 0.25rem 0.75rem;\n  color: white;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.sidebar-link:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n  color: #FFD700; /* Gold color on hover */\n}\n\n.sidebar-link.active {\n  font-weight: bold;\n  color: #FFD700;\n}\n\n.sidebar-dropdown {\n  margin: 1.0rem 0.4rem;\n  padding-left: 0.5rem;\n  cursor: pointer;\n}\n.sidebar-dropdown-header:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n  color: #FFD700; \n}\n\n.sidebar-dropdown summary {\n  cursor: pointer;\n  font-weight: bold;\n  list-style: none;\n  color: white;\n  padding: 0.25rem 0.5rem;\n}\n\n.sidebar-nested {\n  margin-left: 1rem;\n  padding-left: 0.5rem;\n  border-left: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n/* Logo styles */\n.sidebar-logo {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem 0;\n  margin-top: 100px;\n  background-color: transparent !important;\n\n}\n\n.sidebar-logo-img {\n  width: 80%; /* Adjust the width to control the size */\n  max-width: 150px; /* Set a maximum width */\n  border-radius: 6px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
